// extracted by mini-css-extract-plugin
export default {"input":"jut__CurrencyInput__input","inputOverrides":"jut__CurrencyInput__inputOverrides","left":"jut__CurrencyInput__left","right":"jut__CurrencyInput__right"};